<template>
    <keep-alive>
        <component :is="validateComponet" :post_component="post_component" :valueExpire="valueExpire" :valueCreditCard="valueCreditCard" :valueItemPay="valueItemPay"/>
     </keep-alive>
</template>

<script>

 import card from './PaymentInfoForm_card.vue';
 import wechat from './PaymentInfoForm_wechat.vue';
 import alipay from './PaymentInfoForm_alipay.vue';
 import paydefault from './PaymentInfoForm_default.vue';
 import OXXO from './PaymentInfoForm_OXXO.vue';
 import CASH from './PaymentInfoForm_CASH.vue';



import {
    EventBus
} from './EventBus.js';
export default {
    data() {
        return {
            databuyer: "",
            datascope:"",
            datalocale:"",
            post_component:{},
        }
     },
    components: {card, wechat,alipay, OXXO,paydefault,CASH},
    props: {
        //valueinfo: { type: String, default: 'card' },
        valueinfo: {
            type: Object,
            default: function () {
                return { paymentMethod:'card' }
            }
        },
        valueCreditCard: {
            type: Object,
            default: function () {
                return { paymentMethod:'card' }
            }
        },
        valueItemPay: {
            type: Object,
            default: function () {
                return { type:'' }
            }
        },
        valueExpire:{type: String, default: "0"}
    },
    computed:{
        validateComponet(){
             if(this.valueinfo.creditCard != null){
                 return 'paydefault';
             }else if(this.valueinfo.returnPaymentMethod =='CASH'){  
                  return 'CASH';
             }else{
                return this.valueinfo.paymentMethod;
             }
           // return this.valueinfo =="525aa33e27ecac14531e74296c5625aa" ? 'card' : this.valueinfo;
        }
    },
    mounted() {
        this.$nextTick(function() {
            //EventBus.$on('callerData', this.setBuyerData);
            //EventBus.$on('focus', this.setFocus);
            //EventBus.$on('resetForm1', this.reset);
            //EventBus.$on('countries', this.setCountries);
        });
    },
     methods: {
        setBuyerData(data) {
            console.log("setBuyerData >>>>>>"+this.valueinfo);
            const { buyer } = data;
            this.post_component = {...this.post_component,buyer};
     
        },
        setCountries(locale){
            console.log("setCountries >>>>>>>>>>>>>>"+locale);
            this.datalocale = locale;
            this.post_component = {...this.post_component,datalocale:this.datalocale}
        },
     },
}
</script>
<style>
.fa-asterisk:before{
  color:red;
  font-size: .35em;
}
</style>
